import React from "react";
import { BrowserRouter, Switch as Router } from "react-router-dom";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ProductProvider } from './context';

ReactDOM.render(
  <ProductProvider>
    <React.StrictMode>
    <BrowserRouter>
      <Router>
        <App />
      </Router>
    </BrowserRouter>
  </React.StrictMode>
  </ProductProvider>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
